import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import OrderPaymentsTable from "@/components/logistics/order-payments/order-payments-table";

const orderPaymentsSearchSchema = z.object({
  page: z.number().optional().default(1),
  search: z.string().optional(),
  status: z.string().optional(),
  paymentStatus: z.string().optional(),
  shipmentId: z.string().optional(),
});

export const Route = createFileRoute(
  "/_authenticated/logistics/order_payments/",
)({
  validateSearch: orderPaymentsSearchSchema,
  component: OrderPaymentsPage,
});

function OrderPaymentsPage() {
  const searchParams = Route.useSearch();

  return (
    <div className="flex-1 flex flex-col min-h-0">
      <OrderPaymentsTable
        currentPage={searchParams.page}
        pageSize={10}
        basePath="/logistics/order_payments"
        searchParams={searchParams}
      />
    </div>
  );
}
